import debounce from 'lodash/debounce';
import { useCallback, useRef } from 'react';

import settings from '~/settings';
import useMount from '~/hooks/useMount';

import { useAppDispatch, useAppSelector } from '~/store';
import { isGlobalFetchingSelector } from '~/store/selectors/fetchingCounterSelectors';
import { syncAccountInfoThunk } from '~/store/thunks/accountThunks';
import { waitForClanCreation } from '~/Actions/ActionClanCreate';

const AccountInfoSyncManager = () => {
  const isFetching = useAppSelector(isGlobalFetchingSelector);
  const dispatch = useAppDispatch();

  const handleSyncAccountInfo = useCallback(() => dispatch(syncAccountInfoThunk()), [dispatch]);
  const handleWaitForClanCreation = useCallback(() => dispatch(waitForClanCreation()), [dispatch]);

  const syncAccountInfoCb = useCallback(() => {
    // TODO: add abort controller and avoid multiple active syncs after fetching counter refactoring
    if (isFetching) {
      void syncAccountInfoDebounce.current();
    } else {
      handleSyncAccountInfo().then(syncAccountInfoDebounce.current).catch(syncAccountInfoDebounce.current);
    }
  }, [handleSyncAccountInfo, isFetching]);

  const syncAccountInfoDebounce = useRef(debounce(syncAccountInfoCb, settings.ajaxTools.accountInfoSyncTimeout));

  useMount(() => {
    void handleWaitForClanCreation();
    void syncAccountInfoDebounce.current();
  });

  return null;
};

export default AccountInfoSyncManager;
